<template>
<BNavbar
  class="nav-bar"
  toggleable="lg"
  :type="type"
  :variant="variant">

  <BNavbarBrand
    class="brand-title"
    to="/">
    <slot name="brand">
      BRAND
    </slot>
  </BNavbarBrand>

  <BNavbarToggle
    target="nav-collapse">
  </BNavbarToggle>

  <BCollapse id="nav-collapse" isNav>

    <BNavbarNav>
      <slot name="actions">
        <BNavItem to="#">Link</BNavItem>
        <BNavItem to="#" disabled>Disabled</BNavItem>
      </slot>
    </BNavbarNav>

  </BCollapse>

</BNavbar>
</template>

<script>
import {
  BNavbar,
  BNavbarBrand,
  BNavItem,
  BNavbarNav,
  BNavbarItem,
  BCollapse,
  BNavbarToggle,
} from 'bootstrap-vue';

export default {
  name: 'NavBar',
  props: {
    type: {
      type: String,
      default: "dark",
    },
    variant: {
      type: String,
      default: "info",
    },
  },
  data() {
    return {};
  },
  components: {
    'b-navbar': BNavbar,
    'b-navbar-brand': BNavbarBrand,
    'b-navbar-nav': BNavbarNav,
    'b-navbar-item': BNavbarItem,
    'b-navbar-toggle': BNavbarToggle,
    'b-nav-item': BNavItem,
  },
  created() {},
  watch: {},
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';
.nav-bar  {

  .brand-title {
    text-decoration: none;
  }


}
</style>
